import React, { Component } from 'react';
import { Container, Row, Col} from 'reactstrap';

class DataFetchError extends Component {
  render() {
   return (

     <Container fluid={true} >
       <Row className="Header">
         <div className="mx-auto" id="union-logo">
           <img src="/img/sportlink_logo.png" alt="Sportlink logo" />
         </div>
       </Row>
       <Row >
         <Col md={{ size: 10,offset: 1 }} className="formGroup TextCenter">
           <h2>
             Sorry!
           </h2>
           <p>
             Er is helaas een fout opgetreden bij het laden.  Probeer het later nog eens
           </p>
         </Col>
       </Row>
     </Container>
   );
 }
}

export default DataFetchError



// WEBPACK FOOTER //
// ./src/club/DataFetchError.jsx